import { render } from "./ocr_liveness_verification.html?vue&type=template&id=6b989163&scoped=true&external"
import script from "./ocr_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./ocr_liveness_verification.js?vue&type=script&lang=js&external"

import "./OcrLivenessVerificationReport.vue?vue&type=style&index=0&id=6b989163&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b989163"]])

export default __exports__